export const slugifyJobTitle = (title = "") =>
  title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);

export const getJobPath = (job) => {
  const id = job?.id || job?.jobId;
  if (!id) return "/";
  const slug = slugifyJobTitle(job?.title);
  return slug ? `/jobs/${id}/${slug}` : `/jobs/${id}`;
};

export const isJobExpired = (job) =>
  job?.status === "EXPIRED" ||
  job?.status === "CLOSED" ||
  (job?.deadline && new Date(job.deadline) < new Date());

export const isPublishedJobStatus = (status) =>
  ["APPROVED", "EXPIRED", "CLOSED"].includes(status);

export const isPublishedJob = (job) => isPublishedJobStatus(job?.status);
